export type Align = 'left' | 'right' | 'center';

export function textAlignClass(align: Align) {
  return `text-align-${align}`;
}
